import { render, staticRenderFns } from "./studentModule.vue?vue&type=template&id=3c441872&scoped=true"
import script from "./studentModule.vue?vue&type=script&lang=js"
export * from "./studentModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c441872",
  null
  
)

export default component.exports